const PIXEL_CONTACT_STORAGE_KEY = "hs_pixel_contact";

export const getStoredPixelContact = () => {
  try {
    const raw = sessionStorage.getItem(PIXEL_CONTACT_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return {
      phone: parsed?.phone || parsed?.phoneRaw || undefined,
      email: parsed?.email || undefined,
    };
  } catch {
    return {};
  }
};

/** Improve TikTok match quality once we have a phone (or email). */
export const identifyTikTokUser = ({ phone, email } = {}) => {
  if (typeof window === "undefined" || !window.ttq?.identify) return;
  const payload = {};
  if (phone) payload.phone_number = String(phone).replace(/\D/g, "");
  if (email) payload.email = String(email).trim().toLowerCase();
  if (!payload.phone_number && !payload.email) return;
  try {
    window.ttq.identify(payload);
  } catch (err) {
    console.warn("[TikTok] identify failed", err);
  }
};
